
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 20 13","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"#515358"}},[_c('path',{attrs:{"d":"M19.816 6.013C19.633 5.769 15.408.102 10 .102S.367 5.769.184 6.012a.82.82 0 000 .955c.183.244 4.408 5.931 9.816 5.931s9.633-5.667 9.816-5.91a.853.853 0 000-.976zM10 11.273c-3.735 0-7.02-3.473-8.122-4.773C2.98 5.2 6.245 1.727 10 1.727S17.02 5.2 18.122 6.5C17.02 7.8 13.735 11.273 10 11.273z"}}),_c('path',{attrs:{"d":"M10 2.153c-2.408 0-4.367 1.95-4.367 4.347 0 2.397 1.959 4.347 4.367 4.347s4.367-1.95 4.367-4.347c0-2.397-1.959-4.347-4.367-4.347zm0 7.069A2.728 2.728 0 017.265 6.5 2.728 2.728 0 0110 3.778 2.728 2.728 0 0112.735 6.5 2.728 2.728 0 0110 9.222z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/objectMenu/view.svg